import CreateBanner from "./CreateBanner";


export default function MarketBanner() {
    return (
        <div>
            <CreateBanner Type={"PRODUCT"} />
        </div>
    )
}